// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-attachment-modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto; /* Re-enable pointer events for the modal overlay */
  z-index: 2000;
}

.file-attachment-modal-content {
  position: relative;
  width: 500px;
  height: 500px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.file-attachment-modal-close-btn {
  position: absolute;
  top: -16px; /* Position button halfway outside the top edge */
  right: -16px; /* Position button halfway outside the right edge */
  background-color: white;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.file-attachment-modal-close-btn i {
  color: #555;
  font-size: 16px;
}

.file-attachment-modal-actions {
  position: absolute;
  top: 60px;
  right: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 10;
}

.file-attachment-modal-action-btn {
  background-color: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  transition: background-color 0.2s ease;
}

.file-attachment-modal-action-btn i {
  color: black;
  font-size: 16px;
}

.file-attachment-modal-react-icon {
  width: 18px;
  height: 18px;
}

.file-attachment-modal-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  max-height: 400px;
  overflow: auto;
  width: 100%;
}

.file-attachment-modal-text-preview {
  width: 100%;
  max-height: 400px;
  overflow: auto;
  background-color: #f8f8f8;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  text-align: left;
}

.file-attachment-modal-text-preview pre {
  margin: 0;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
  color: #333;
}

.file-attachment-modal-loading {
  font-size: 16px;
  color: #777;
  font-style: italic;
}

.file-attachment-modal-icon {
  width: 128px;
  height: 128px;
  margin-bottom: 20px;
}

.file-attachment-modal-filename {
  font-size: 20px;
  font-weight: 500;
  color: #333;
}

.file-attachment-modal-file-info,
.file-attachment-modal-file-size {
  font-size: 16px;
  color: #777;
}

.file-attachment-modal-reactions {
  position: absolute;
  bottom: 20px;
  left: 20px;
}

.file-attachment-modal-emoji-picker-container {
  position: fixed;
  top: 350px;
  right: 250px;
  z-index: 2002;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
}

/* Malware warning toast */
.file-attachment-modal-malware-toast {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10001;
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #2d2d2d;
  color: #fff;
  border-left: 4px solid #f0ad4e;
  border-radius: 6px;
  padding: 12px 16px;
  max-width: 480px;
  width: max-content;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.45);
  animation: file-attachment-toast-fade-in 0.25s ease;
}

@keyframes file-attachment-toast-fade-in {
  from { opacity: 0; transform: translateX(-50%) translateY(12px); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0); }
}

.file-attachment-modal-malware-toast-icon {
  color: #f0ad4e;
  font-size: 18px;
  flex-shrink: 0;
}

.file-attachment-modal-malware-toast-text {
  font-size: 13px;
  line-height: 1.4;
  flex: 1;
}

.file-attachment-modal-malware-toast-dismiss {
  background: none;
  border: none;
  color: #aaa;
  cursor: pointer;
  padding: 0 2px;
  font-size: 14px;
  flex-shrink: 0;
  line-height: 1;
}

.file-attachment-modal-malware-toast-dismiss:hover {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/FileAttachmentModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB,EAAE,mDAAmD;EACzE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,iDAAiD;EAC7D,YAAY,EAAE,mDAAmD;EACjE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4EAA4E;EAC5E,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,mDAAmD;AACrD;;AAEA;EACE,OAAO,UAAU,EAAE,4CAA4C,EAAE;EACjE,OAAO,UAAU,EAAE,yCAAyC,EAAE;AAChE;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".file-attachment-modal-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto; /* Re-enable pointer events for the modal overlay */\n  z-index: 2000;\n}\n\n.file-attachment-modal-content {\n  position: relative;\n  width: 500px;\n  height: 500px;\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.file-attachment-modal-close-btn {\n  position: absolute;\n  top: -16px; /* Position button halfway outside the top edge */\n  right: -16px; /* Position button halfway outside the right edge */\n  background-color: white;\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 10;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.file-attachment-modal-close-btn i {\n  color: #555;\n  font-size: 16px;\n}\n\n.file-attachment-modal-actions {\n  position: absolute;\n  top: 60px;\n  right: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  z-index: 10;\n}\n\n.file-attachment-modal-action-btn {\n  background-color: rgba(255, 255, 255, 0.9);\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\n  transition: background-color 0.2s ease;\n}\n\n.file-attachment-modal-action-btn i {\n  color: black;\n  font-size: 16px;\n}\n\n.file-attachment-modal-react-icon {\n  width: 18px;\n  height: 18px;\n}\n\n.file-attachment-modal-details {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 8px;\n  max-height: 400px;\n  overflow: auto;\n  width: 100%;\n}\n\n.file-attachment-modal-text-preview {\n  width: 100%;\n  max-height: 400px;\n  overflow: auto;\n  background-color: #f8f8f8;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 16px;\n  text-align: left;\n}\n\n.file-attachment-modal-text-preview pre {\n  margin: 0;\n  font-family: 'Courier New', monospace;\n  font-size: 13px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  color: #333;\n}\n\n.file-attachment-modal-loading {\n  font-size: 16px;\n  color: #777;\n  font-style: italic;\n}\n\n.file-attachment-modal-icon {\n  width: 128px;\n  height: 128px;\n  margin-bottom: 20px;\n}\n\n.file-attachment-modal-filename {\n  font-size: 20px;\n  font-weight: 500;\n  color: #333;\n}\n\n.file-attachment-modal-file-info,\n.file-attachment-modal-file-size {\n  font-size: 16px;\n  color: #777;\n}\n\n.file-attachment-modal-reactions {\n  position: absolute;\n  bottom: 20px;\n  left: 20px;\n}\n\n.file-attachment-modal-emoji-picker-container {\n  position: fixed;\n  top: 350px;\n  right: 250px;\n  z-index: 2002;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n}\n\n/* Malware warning toast */\n.file-attachment-modal-malware-toast {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10001;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: #2d2d2d;\n  color: #fff;\n  border-left: 4px solid #f0ad4e;\n  border-radius: 6px;\n  padding: 12px 16px;\n  max-width: 480px;\n  width: max-content;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.45);\n  animation: file-attachment-toast-fade-in 0.25s ease;\n}\n\n@keyframes file-attachment-toast-fade-in {\n  from { opacity: 0; transform: translateX(-50%) translateY(12px); }\n  to   { opacity: 1; transform: translateX(-50%) translateY(0); }\n}\n\n.file-attachment-modal-malware-toast-icon {\n  color: #f0ad4e;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.file-attachment-modal-malware-toast-text {\n  font-size: 13px;\n  line-height: 1.4;\n  flex: 1;\n}\n\n.file-attachment-modal-malware-toast-dismiss {\n  background: none;\n  border: none;\n  color: #aaa;\n  cursor: pointer;\n  padding: 0 2px;\n  font-size: 14px;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.file-attachment-modal-malware-toast-dismiss:hover {\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
